export const currencyOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
